import type { FC } from 'react';

const STEPS = [
  { id: 1, label: 'GT', fullLabel: 'Giới thiệu' },
  { id: 2, label: 'CCCD', fullLabel: 'CCCD trước' },
  { id: 3, label: 'Mặt sau', fullLabel: 'CCCD sau' },
  { id: 4, label: 'Selfie', fullLabel: 'Chân dung' },
  { id: 5, label: 'OCR', fullLabel: 'Xác nhận TT' },
  { id: 6, label: 'Gửi', fullLabel: 'Gửi hồ sơ' },
  { id: 7, label: 'KQ', fullLabel: 'Kết quả' },
];

interface EkycStepHeaderProps {
  currentStep: number;
}

const EkycStepHeader: FC<EkycStepHeaderProps> = ({ currentStep }) => {
  return (
    <div className="w-full">
      {/* Mobile: circles only with short labels */}
      <div className="flex items-center justify-center gap-0 sm:hidden">
        {STEPS.map((step, idx) => {
          const isCompleted = currentStep > step.id;
          const isActive = currentStep === step.id;
          const isLast = idx === STEPS.length - 1;

          return (
            <div key={step.id} className="flex items-center">
              <span
                className={`w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-bold transition-all shrink-0 ${
                  isCompleted
                    ? 'bg-agrida-500 text-white'
                    : isActive
                      ? 'bg-agrida-600 text-white ring-2 ring-agrida-200'
                      : 'bg-gray-100 text-gray-400'
                }`}
              >
                {isCompleted ? <i className="ri-check-line text-[10px]" /> : step.id}
              </span>
              {!isLast && (
                <div
                  className={`w-2.5 h-0.5 rounded-full transition-colors ${
                    isCompleted ? 'bg-agrida-400' : 'bg-gray-200'
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>

      {/* Desktop: full labels */}
      <div className="hidden sm:flex items-center justify-between px-1">
        {STEPS.map((step, idx) => {
          const isCompleted = currentStep > step.id;
          const isActive = currentStep === step.id;
          const isLast = idx === STEPS.length - 1;

          return (
            <div key={step.id} className="flex items-center flex-1 last:flex-none">
              <div className="flex flex-col items-center gap-1">
                <span
                  className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold transition-all ${
                    isCompleted
                      ? 'bg-agrida-500 text-white'
                      : isActive
                        ? 'bg-agrida-600 text-white ring-2 ring-agrida-200'
                        : 'bg-gray-100 text-gray-400'
                  }`}
                >
                  {isCompleted ? <i className="ri-check-line text-xs" /> : step.id}
                </span>
                <span
                  className={`text-[10px] font-medium leading-tight text-center whitespace-nowrap transition-colors ${
                    isActive ? 'text-agrida-700' : isCompleted ? 'text-agrida-500' : 'text-gray-400'
                  }`}
                >
                  {step.fullLabel}
                </span>
              </div>
              {!isLast && (
                <div
                  className={`flex-1 h-0.5 mx-0.5 mt-[-14px] rounded-full transition-colors ${
                    isCompleted ? 'bg-agrida-400' : 'bg-gray-200'
                  }`}
                />
              )}
            </div>
          );
        })}
      </div>

      {/* Current step name for mobile context */}
      <p className="text-center text-[11px] font-medium text-gray-400 mt-1 sm:hidden">
        Bước {currentStep}/7 — {STEPS[currentStep - 1]?.fullLabel || ''}
      </p>
    </div>
  );
};

export default EkycStepHeader;